export const buildProcessPaymentPayload = (originalPayload) => {
    let payload = {
        paymentMethod: '',
        gateway: 'stripe',
        cardID:
            originalPayload.CreditCardID !== undefined &&
                originalPayload.CreditCardID &&
                originalPayload.CreditCardID != 'add-new-card'
                ? originalPayload.CreditCardID
                : 0,
        saveCard:
            originalPayload.SaveCard !== undefined
                ? originalPayload.SaveCard
                : false,
        token: originalPayload.Token || '',
    };

    if (typeof payload.saveCard == 'string') {
        payload.saveCard = Number(payload.saveCard) == 1;
    }

    if (payload.saveCard == true) {
        let cardName = originalPayload.CardName || '';

        payload = {
            ...payload,
            card: {
                cardName: cardName,
                name: cardName,
                number: originalPayload.Number || '',
                expiryMonth: originalPayload.ExpiryMonth || '',
                expiryYear: originalPayload.ExpiryYear || '',
            },
        };
    }

    // Payment Method
    if (typeof originalPayload.PaymentMethod != 'undefined') {
        if (originalPayload.PaymentMethod == 'banktransfer') {
            payload.paymentMethod = 'order-bank-transfer';
        } else if (originalPayload.PaymentMethod == 'accountbalance') {
            payload.paymentMethod = 'order-account';
        } else if (originalPayload.PaymentMethod == 'stripe') {
            payload.paymentMethod = 'order-card-authorization';
        }
    }

    return payload;
};

export const buildUpdateOrderPayload = (originalPayload, data) => {

    const { deliveryOptions } = data;
    const selectedDeliveryOption =
        deliveryOptions[originalPayload.ShippingID] || null;

    let payload = {
        BillingAddressID: Number(originalPayload.BillingAddressID),
        // ShippingAddressID: Number(originalPayload.DeliveryAddressID),
        Notes: originalPayload.Notes || '',
        ExtraAttribute1: originalPayload.PurchaseOrderNumber || '',
    };

    if (selectedDeliveryOption) {
        payload = {
            ...payload,
            PostmenSelectedShipperInternalID:
                selectedDeliveryOption.ShipperInternalID,
            PostmenSelectedShipperExternalID:
                selectedDeliveryOption.ShipperExternalID,
            PostmenSelectedShipperServiceType:
                selectedDeliveryOption.ShipperServiceType,
        };

        if (selectedDeliveryOption.ID) {
            payload = {
                ...payload,
                ShippingID: selectedDeliveryOption.ID,
            };
        }
    }

    if (
        window.currentOrderPaymentMethod ==
        'order-card-authorization-payfast' &&
        window.isEditOrder
    ) {
        payload = {
            ...payload,
            PostmenSelectedShipperInternalID:
                window.PostmenSelectedShipperInternalID,
            PostmenSelectedShipperExternalID:
                window.PostmenSelectedShipperExternalID,
            PostmenSelectedShipperServiceType:
                window.PostmenSelectedShipperServiceType,
            ShippingID: window.currentOrderShippingID,
        };
    }

    return payload;
};
